import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_PowerMetric_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_POWERMETRIC_ID:    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Model Function Id',       columnResourceName: 'colId',                     alignment: HorizAlignment.Left},    domainOptions: {} },
    POWERMETRIC_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Function Id',          columnResourceName: 'colId',                     alignment: HorizAlignment.Left},    domainOptions: {maxLength: 50}},
    POWERMETRIC_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Function Name',        columnResourceName: 'colModelFunctionName',      alignment: HorizAlignment.Left},    domainOptions: {maxLength: 50}},
    DELETED_IND:                {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind',                columnResourceName: 'colDeletedInd',             alignment: HorizAlignment.Left},    domainOptions: {}},
    DELETED_DT:                 {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',               columnResourceName: 'colDeletedDate',            alignment: HorizAlignment.Left},    domainOptions: {}},
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelPowerMetricSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_MODEL_POWERMETRIC_ID',
        id_ui: 'POWERMETRIC_ID',
        name:  'POWERMETRIC_NAME'
    },

    searchProviderFields: vUI_Model_PowerMetric_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_PowerMetric_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ModelPowerMetricSearchProfileByName: ISearchProfile = {
    profileId:      "default",
    profileName:    "Search by Id, Name",
    renderOptions:  {ui5SourceId: "ModelPowerMetricSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',   searchProviderFieldId: 'POWERMETRIC_ID',    renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'POWERMETRIC_NAME',  renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'POWERMETRIC_ID', 'POWERMETRIC_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelPowerMetricSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelPowerMetricSearch: ISearch = {
    searchName:             "Find Model Power Metric",
    renderOptions:          {ui5ResourceId: "ModelPowerMetricSearch"},
    searchProfileIdDefault: "default",
    searchProfiles:         [ModelPowerMetricSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelPowerMetricBO", "ModelPowerMetric", ModelPowerMetricSearch, "Model Power Metric Search")

export {ModelPowerMetricSearch}